import { FC } from 'react';
import { ATTIO_PAST_VALUATIONS_FILTER } from 'dashboard409a/common/constants/analyst-dashboard';
import WorkboardDataTable from '../WorkboardDataTable';

const WorkboardPastJobs: FC = () => (
  <WorkboardDataTable
    filters={ATTIO_PAST_VALUATIONS_FILTER}
  />
);

export default WorkboardPastJobs;
